import React, { PureComponent } from "react";
import Popup from "./Popup.js";
import Button from "../Button/Button.js";

import Constants from '../Constants.js';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb } from '@fortawesome/free-solid-svg-icons';
library.add(faLightbulb);



class PopupGetHints extends PureComponent {

    constructor(props) {
        super(props);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.addHints = this.addHints.bind(this);
        this.popup = React.createRef();
    }

    show() {
        this.popup.current.show();
    }
    hide() {
        this.popup.current.hide();
    }

    addHints(hints) {
        // Update local storage after purchase
        let data = this.props.data;
        data.hintsRemaining = data.hintsRemaining + hints;
        if (typeof this.props.onUpdateData === 'function')
            this.props.onUpdateData(data);
    }

    render() {

        let price1 = this.props.prices.hints1;
        let price2 = this.props.prices.hints2;
        let price3 = this.props.prices.hints3;

        return (
            <Popup
                ref={this.popup}
                showing={false}
            >
                <h1 className="Title">
                    Get More Hints?
                </h1>
                <div className="Wrapper">
                    <FontAwesomeIcon
                        className="LightbulbIcon"
                        icon="lightbulb"
                    />
                </div>
                <p className="Paragraph">
                    Feeling stuck? Hints can help you solve a level by revealing one of its hidden words.
                </p>
                <div
                    style={{
                        display: 'inline-block',
                        boxSizing: 'border-box',
                    }}
                >
                    <Button
                        activeColor={'#fff'}
                        inactiveColor={'#3c40c6'}
                        borderColor={'#3c40c6'}
                        onClick={() => {
                            if (window.store) {
                                window.store.order('hints1');
                            }
                            this.hide();
                        }}
                    >
                        +{Constants.hintAmounts[0]} Hints
                    </Button>
                    <div
                        className="Price"
                    >
                        {price1 && 'for ' + price1}
                    </div>
                </div>
                <div
                    style={{
                        display: 'inline-block',
                        boxSizing: 'border-box',
                    }}
                >
                    <Button
                        activeColor={'#fff'}
                        inactiveColor={'#3c40c6'}
                        borderColor={'#3c40c6'}
                        onClick={() => {
                            if (window.store) {
                                window.store.order('hints2');
                            }
                            this.hide();
                        }}
                    >
                        +{Constants.hintAmounts[1]} Hints
                    </Button>
                    <div
                        className="Price"
                    >
                        {price2 && 'for ' + price2}
                    </div>
                </div>
                <div
                    style={{
                        display: 'inline-block',
                        boxSizing: 'border-box',
                    }}
                >
                    <Button
                        activeColor={'#fff'}
                        inactiveColor={'#3c40c6'}
                        borderColor={'#3c40c6'}
                        onClick={() => {
                            if (window.store) {
                                window.store.order('hints3');
                            }
                            this.hide();
                        }}
                    >
                        +{Constants.hintAmounts[2]} Hints
                    </Button>
                    <div
                        className="Price"
                    >
                        {price3 && 'for ' + price3}
                    </div>
                </div>
            </Popup>
        );
    }
}

export default PopupGetHints;
